import * as actionConsts from './actions';
import update from 'react/lib/update';
import * as dailyReportActionConsts from '../actions';

export const initState = {
  deliveryNotes: [],
  supplierSuggestions: []
}


export default (state=initState, action) => {
  switch (action.type) {
    case dailyReportActionConsts.DAILY_REPORT_GET_SUCCESS:
      return update(state, {
        deliveryNotes: {
          $set: action.deliveryNotes
        }
    });
    case actionConsts.UPDATE_DELIVERY_NOTE:
      return update(state, {
        deliveryNotes: {
          [action.index]: {
            [action.typeOf]: {
              $set: action.value
            }
          }
        }
    });
    case actionConsts.UPDATE_DELIVERY_NOTE_TOUCHED:
      return update(state, {
        deliveryNotes: {
          [action.index]: {
            [action.typeOf]: {
              $set: true
            }
          }
        }
    });
    case actionConsts.ADD_DELIVERY_NOTE:
      return update(state, {
        deliveryNotes: {
          $push: [action.deliveryNote]
        }
    });
    case actionConsts.GET_SUPPLIER_SUGGESTIONS_SUCCESS:
      return update(state, {
        supplierSuggestions: {
          $set: action.suggestions
        }
    });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/DeliveryNotes/reducer.js